import { bWareDescription } from "src/app/(normal)/(shop)/b-ware/metaData"
import { mapLineBreaksToHtmlBreaks } from "src/utilities/html"
import { useProductContext } from "../context"

export const ProductDescription = () => {
  const product = useProductContext()

  const { resolvedSku } = product
  let description = product.description || ""

  if (resolvedSku?.includes("(B)")) {
    description = [bWareDescription, description].filter(Boolean).join("\n\n")
  }

  if (!description) {
    return null
  }

  return <div className="RichText" dangerouslySetInnerHTML={{ __html: mapLineBreaksToHtmlBreaks(description) }} />
}
